import React, { useState, useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import FilterComponent from '../common/FilterComponent';
import Header from '../common/Header';
import SubHeader from '../common/SubHeader';
import withMasterData from '../MasterComponent';
import ExpenseFilter from '../Modal/ExpenseFilter';
import ExpenseTable from './ExpenseTable';
import filterExpenseItems from './queries/filterExpenseItems';
import SearchBar from '../common/SearchBar';
import ButtonComponent from '../common/ButtonComponent';
import plusIcon from '../../images/icons/plus_icon.svg';
import { resetFilter } from '../../features/fliter/filterSlice';
import { resetVendorFilter } from '../../features/fliter/filterSliceVendor';
import { resetPage } from '../../features/pagecount/pageSlice';
import { returnPolicies } from '../../PermissionUtility/ProfilePolicies';
import formatDropdownOptions from '../../utils/formatDropdownOptions';
import { apiurl } from '../../config/apiUrl';
import axios from '../../utils/axios';

const ExpenseItems = ({
  categoryList,
  accountCodeList }) => {
  const [addNewField, setaddNewField] = useState(false);
  const [search, setsearch] = useState('');
  const [modal, setModal] = useState(false);
  const [isEdit, setEditRowId] = useState(null);
  const [activePanel, setActivePanel] = useState(false);

  const [filterData, setFilterData] = useState({
    purposeID: '',
    accountCodeID: '',
    expenseCategoryID: '',
    documentIdentifier: ''
  });
  const [pageNumber, setpageNumber] = useState(1);
  const [rowsCount, setrowsCount] = useState(10);
  const [documentMappingList, setDocumentMappingList] = useState(null);
  const policies = returnPolicies();
  const history = useHistory();
  const handleAddNewField = () => {
    setActivePanel(true);
    if (isEdit) {
    setEditRowId(null);
    setaddNewField((prevState) => !prevState);
    } else {
    setaddNewField((prevState) => !prevState);
    }
  };
  const handleSearch = (value) => {
    setsearch(value);
  };
  const fetchData = async () => {
    const response = await axios.get(`${apiurl?.getCourceList}`);
    setDocumentMappingList(formatDropdownOptions(response?.data,
      'courseName', 'documentIdentifier'));
  };
  const { mutate: filterExpenseItem, isLoading: isFiltering } = filterExpenseItems();

  const initiateFilter = (data) => {
    filterExpenseItem({ ...data, expenseLineItem: search, pageNumber, rowsCount });
  };
  const dispatch = useDispatch();
  useEffect(() => {
    fetchData();
    dispatch(resetFilter());
    dispatch(resetPage());
    dispatch(resetVendorFilter());
  }, []);

  useEffect(() => {
    if (policies?.expensePolicies.canAccess === false) {
      history.push('/');
    }
    }, [policies]);

  return (
    <>
    {policies?.expensePolicies.canAccess && (
    <div className="md:w-full">
      <Header parentPageLink="/" currentPage={addNewField ? 'Add Expense Item' : 'Expense Item List'} headerName="Expense Items" />
      <div className="manning-wrapper">
        <SubHeader
          addButton
          addNewField={addNewField}
          pageNumber={pageNumber}
          rowsCount={rowsCount}
          filterButton={<FilterComponent setModal={setModal} />}
          searchComponent={(
            <SearchBar
              handleSearch={handleSearch}
              search={search}
              placeholder="Search Expense Item (Minimum 3 characters)"
              additionalClassName="search-input-width"
            />
          )}
          addButtonComponent={policies?.expensePolicies.canEdit && (
            <ButtonComponent
              handleClick={handleAddNewField}
              name="CREATE EXPENSE ITEM"
              icon={plusIcon}
            />
          )}
          expenseFilter={(
            <ExpenseFilter {...{
              setModal,
              modal,
              categoryList,
              documentMappingList,
              accountCodeList,
              filterData,
              setFilterData,
              initiateFilter
            }}
            />
          )}
        />

        <ExpenseTable
          policies={policies}
          isEdit={isEdit}
          setEditRowId={setEditRowId}
          addNewField={addNewField}
          setaddNewField={handleAddNewField}
          search={search}
          setActivePanel={setActivePanel}
          activePanel={activePanel}
          categoryList={categoryList}
          documentMappingList={documentMappingList}
          accountCodeList={accountCodeList}
          pageNumber={pageNumber}
          setpageNumber={setpageNumber}
          rowsCount={rowsCount}
          setrowsCount={setrowsCount}
          filterData={filterData}
          isFiltering={isFiltering}
        />

      </div>
    </div>
          )}
    </>
  );
};

export default withMasterData(ExpenseItems);
